import { atom } from "jotai";
import { FinancialProductReadDTO } from "../types/FinancialApplication";

export interface SelectedProductDetail {
  product: FinancialProductReadDTO;
  depositApplicationId: string;
}

// Atom to store selected product details (no persistence)
export const selectedProductDetailsAtom = atom<SelectedProductDetail[]>([]);

// Atom to store the loading state
export const selectedProductsLoadingAtom = atom<boolean>(false); 